import React, { useState } from "react";
import "../assets/style/product/productMain.scss";
import ProductCard from "./ProductCard";
import { Redirect, useParams } from "react-router-dom";
import { connect } from "react-redux";
import { useEffect } from "react";
import {
  set_deleted_images,
  set_product_details,
  set_variants,
} from "../redux/actions/ProductsAction";
import { apiJson } from "../api/Api";
import { toast } from "react-toastify";
import { set_loading } from "../redux/actions/LayoutAction";
import { deleteS3Image } from "../utils/utils";

function ProductMain(props) {
  const { state, id } = useParams();
  const [redirect, setRedirect] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(false);
  const [product, setProduct] = useState(
    state !== "create" ? props.productDetails : {}
  );

  let message = "";

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };
  useEffect(() => {
    props.set_deleted_images({
      deletedImagesUrl: [],
    });
    if (id !== "create") {
      apiJson.products.getProductDetail(id).then((response) => {
        if (response.success) {
          props.set_product_details({ productDetails: response.data });
          props.set_variants(response.data.variants);

          setProduct(response.data);

          setData(true);
        } else if (!response.status) {
          // eslint-disable-next-line
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
          setData(true);
        } else {
          setData(true);
          if (response.status >= 400 && response.status < 500) {
            message = response.message
              ? response.message
              : response.errors
                ? response.errors
                : "something went wrong";
            showError();
          } else {
            message = response.message
              ? response.message !== ""
                ? response.message
                : "something went wrong"
              : "something went wrong";
            showError();
          }
        }
      })
    }
    else {
      props.set_variants([]);
    }

    id === "create" && setProduct({});
    id === "create" && setData(true);
  }, [state, id]);

  const onSave = (val) => {
    if (props.variants?.length < 1) {
      message = "Please add atleast one variant";
      showError();
    } else {
      deleteS3Image(props.deletedImagesUrl);
      setLoading(true);
      apiJson.products
        .createProduct({
          product: {
            ...val,
            variants_attributes: [
              ...props.variants.map((variant) => {
                delete variant["id"];

                if(!variant.enable_3d_image && variant.android_3d_image) {
                  try {
                    deleteS3Image([variant.android_3d_image])
                  } catch (error) {}
                }
                
                return {
                  ...variant,
                  name_ar:
                    variant.name_ar?.length > 1
                      ? variant.name_ar
                      : variant.name_en,
                  description_ar:
                    variant.description_ar?.length > 1 &&
                      variant.description_ar !== "<p><br></p>"
                      ? variant.description_ar
                      : variant.description_en,
                  benefits_ar:
                    variant.benefits_ar?.length > 1 &&
                      variant.benefits_ar !== "<p><br></p>"
                      ? variant.benefits_ar
                      : variant.benefits_en,
                  features_ar:
                    variant.features_ar?.length > 1 &&
                      variant.features_ar !== "<p><br></p>"
                      ? variant.features_ar
                      : variant.features_en,
                  how_to_use_ar:
                    variant.how_to_use_ar?.length > 1 &&
                      variant.how_to_use_ar !== "<p><br></p>"
                      ? variant.how_to_use_ar
                      : variant.how_to_use_en,
                  discounted_price:
                    val.product_type == "wholesale" ?
                      0
                      :
                      variant.discounted_price &&
                        parseFloat(variant.discounted_price) > 0
                        ? variant.discounted_price
                        : variant.price,
                  discount_percentage:
                    variant.discounted_price &&
                      parseFloat(variant.discounted_price) > 0
                      ?
                      ((variant.price - variant.discounted_price) / variant.price) * 100
                      :
                      0,
                  price: val.product_type == "wholesale" ?
                    0
                    :
                    variant.price,
                  quantity: val.product_type == "wholesale" || val.is_inquiry == true ?
                    0
                    :
                    variant.quantity,
                  upc_code: variant.upc_code,
                  ...(!variant.enable_3d_image && { android_3d_image: "", image_placement: 'floor' })
                };
              }),
            ],
          },
        })
        .then((response) => {
          if (response.success) {
            setLoading(false);
            setRedirect(true);
          } else if (!response.status) {
            setLoading(false);
            message = response.message
              ? response.message !== ""
                ? response.message
                : "something went wrong"
              : "something went wrong";
            showError();
          } else {
            setLoading(false);
            if (response.status >= 400 && response.status < 500) {
              message = response.message
                ? response.message
                : response.errors
                  ? response.errors
                  : "something went wrong";
              showError();
            } else {
              message = response.message
                ? response.message !== ""
                  ? response.message
                  : "something went wrong"
                : "something went wrong";
              showError();
            }
          }
        });
    }
  };

  const onUpdate = (val) => {
    if (props.variants?.length < 1) {
      message = "Please add atleast one variant";
      showError();
    } else {
      deleteS3Image(props.deletedImagesUrl);
      setLoading(true);
      apiJson.products
        .updateProduct(val.id, {
          product: {
            ...val,
            variants_attributes: [
              ...props.variants.map((variant) => {
                !variant._destroy &&
                  typeof variant.id === "string" &&
                  delete variant["id"];

                if(!variant.enable_3d_image && variant.android_3d_image) {
                  try {
                    deleteS3Image([variant.android_3d_image])
                  } catch (error) {}
                }

                return {
                  ...variant,
                  name_ar:
                    variant.name_ar?.length > 1
                      ? variant.name_ar
                      : variant.name_en,
                  description_ar:
                    variant.description_ar?.length > 1 &&
                      variant.description_ar !== "<p><br></p>"
                      ? variant.description_ar
                      : variant.description_en,
                  benefits_ar:
                    variant.benefits_ar?.length > 1 &&
                      variant.benefits_ar !== "<p><br></p>"
                      ? variant.benefits_ar
                      : variant.benefits_en,
                  features_ar:
                    variant.features_ar?.length > 1 &&
                      variant.features_ar !== "<p><br></p>"
                      ? variant.features_ar
                      : variant.features_en,
                  how_to_use_ar:
                    variant.how_to_use_ar?.length > 1 &&
                      variant.how_to_use_ar !== "<p><br></p>"
                      ? variant.how_to_use_ar
                      : variant.how_to_use_en,
                  discounted_price:
                    variant.discounted_price &&
                      parseFloat(variant.discounted_price) > 0
                      ? variant.discounted_price
                      : variant.price,
                  discount_percentage:
                    variant.discounted_price &&
                      parseFloat(variant.discounted_price) > 0
                      ?
                      ((variant.price - variant.discounted_price) / variant.price) * 100
                      :
                      0,
                  quantity: val.product_type == "wholesale" || val.is_inquiry == true ?
                    0
                    :
                    variant.quantity,
                  upc_code: variant.upc_code,
                  ...(!variant.enable_3d_image && { android_3d_image: "", image_placement: 'floor' })
                };
              }),
            ],
          },
        })
        .then((response) => {
          if (response.success) {
            setLoading(false);
            setRedirect(true);
          } else if (!response.status) {
            setLoading(false);
            message = response.message
              ? response.message !== ""
                ? response.message
                : "something went wrong"
              : "something went wrong";
            showError();
          } else {
            setLoading(false);
            if (response.status >= 400 && response.status < 500) {
              message = response.message
                ? response.message
                : response.errors
                  ? response.errors
                  : "something went wrong";
              showError();
            } else {
              message = response.message
                ? response.message !== ""
                  ? response.message
                  : "something went wrong"
                : "something went wrong";
              showError();
            }
          }
        });
    }
  };

  // eslint-disable-next-line
  useEffect(() => props.set_loading(!data), [data]);
  return (
    <div>
      <div className="product-main-desktop p-3">
        {data && (
          <div className="form">
            <ProductCard
              loading={loading}
              product={product}
              onSave={(val) => {
                setProduct(val);
                onSave(val);
              }}
              onUpdate={(val) => {
                setProduct(val);
                onUpdate(val);
              }}
              onClose={() => setRedirect(true)}
            />
          </div>
        )}
      </div>
      {redirect && <Redirect push to="/vendor/product-catalog" />}
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    categories: state.category.categories,
    brands: state.brand.brands,
    productDetails: state.product.productDetails,
    load: state.layout.isLoading,
    variants: state.product.variants,
    deletedImagesUrl: state.product.deletedImagesUrl,
  };
};

const mapDispatchToProps = {
  set_variants,
  set_product_details,
  set_loading,
  set_deleted_images,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductMain);
